export const getFormattedLandingPageData = (components,landingPageComponentThemes=[]) =>{
  return components.map((component,index)=>{
    let landingFeaturePointsData = [];
    let featureSectionData = [];
    let landingPlanData = [];
    let faqData = [];
    let contentsCategoryData = [];
    let channelsData= [];
      const {contents = [],type, sysId = ''} = component;
      const [{curatedData = []}=[]] = contents;
      const [curatedDataContents ={}] = curatedData;
      const {
      name='',
      title='',
      subTitle='',
      description='',
      ctaData='',
      ctaDescription='',
      ctaAction = '' ,
      ctaLink = '',
      
    } = curatedDataContents || {};
    if(type === 'landing_feature'){
        featureSectionData =contents.map((item) => {
            const {curatedData:[landingFeaturesCuratedData = {}] = []} = item
            const {listData: landingFeatureListData = []} = landingFeaturesCuratedData
            const newListData = landingFeatureListData.map((listItem) => {
              return(
                {
                  label : listItem.value
                }
              )
            })
            return (
              {
                subTitle: landingFeaturesCuratedData.subTitle,
                title: landingFeaturesCuratedData.title,
                description: landingFeaturesCuratedData.description,
                listData: newListData,
                graphics: {
                  img: landingFeaturesCuratedData.graphics?.[0]?.images?.[0]?.imageUrl || landingFeaturesCuratedData.graphics?.[0]?.images?.[0]?.media?.file?.url,
                  anchor: landingFeaturesCuratedData.graphics?.[0]?.anchor,
                },
                background: ''
              }
            )
          })
    }
    if(type === 'landing_feature_points'){
        landingFeaturePointsData = curatedData.map((item) => {
            const {graphics:[{images:[{imageUrl, media:{file={}}={}}={}]=[]} =[]] = []} = item;
            return(
              {
                graphics : imageUrl || file.url,
                title : item.title,
                description : item.description
              }
            )
          })
    }
    if(type === 'landing_faq'){
        const[,...bottomFAQQuestion] = curatedData;
       
        faqData = bottomFAQQuestion.map((item) => {
          return(
          {
            graphics: {
              img: '',
              anchor: '',
            },
            title: item.title,
            description: item.description,
            data: '',
            params: '',
            ctaData: '',
            listData: null,
          }
          )
        })
    }
    if(type === 'landing_plan'){
        const [, ...landingPlanSubscriptionSection] = curatedData;
         landingPlanData = landingPlanSubscriptionSection.map((item) => {
            const {listData: subscriptionPlanListData = []} = item
            const subscriptionPlanListContent = subscriptionPlanListData.map((listItem) => {
              return(
                {
                  label : listItem.value
                }
              )
            })
            return (
              {
                graphics: {
                  img: item.graphics?.[0]?.images?.[0]?.imageUrl || item.graphics?.[0]?.images?.[0]?.media?.file?.url,
                  anchor: '',
                },
                description: item.description,
                ctaData: item.ctaData,
                params: item.params || '',
                listData: subscriptionPlanListContent,
                data: item.data
              }
            )
          })
    }
    if(type === 'landing_channels'){
        const [,...landingChannelsContentSection] = curatedData || [];
        channelsData = landingChannelsContentSection.map((item) => {
            return(
              {
                graphics: {
                  img: item.graphics?.[0]?.images?.[0]?.imageUrl || item.graphics?.[0].images?.[0]?.media?.file?.url,
                  anchor: '',
                },
                title: '',
                data: '',
                params: '',
                ctaData: '',
                listData: null,
              }
            )
          })
    }
    if(type === 'landing_content_category')
    {
        const [,...landingAssestsContentSection] =curatedData || [];
        contentsCategoryData = landingAssestsContentSection.map((item) => {
            return(
              {
                graphics : {
                  img: item.graphics?.[0]?.images?.[0]?.imageUrl || item.graphics?.[0]?.images?.[0]?.media?.file?.url,
                  anchor: ""
                },
                title : item.title,
                data: '',
                params: '',
                ctaData: '',
                listData: null,
              }
            )
          })
    }
      const sectionData = {
        name,
        title,
        subTitle,
        description,
        ctaData,
        ctaDescription,
        type,
        background:'',
        ctaAction,
        ctaLink,
        sysId
      }
      return ({

          type,
          theme : landingPageComponentThemes[index] && landingPageComponentThemes[index].componentTheme,
          landingPlanData,
          sectionData,
          landingFeaturePointsData,
          featureSectionData,
          faqData,
          channelsData,
          contentsCategoryData,
          key: index,
      }) 
  })
}